import React, { Fragment, useCallback, useEffect } from "react";
import "./index.css";
import { useHistory, useLocation } from "react-router-dom";
import { Button, List } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { loadColors } from "../../../../../../../application/colors-slice";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../application/store";
import { Color } from "../../../../../../../domain";
import { useQuery } from "../../../../../../hooks";
import I18n from "../../../../../../i18n";

type ColorsProps = { selectedColors: Color[] };

const Colors: React.FC<ColorsProps> = ({ selectedColors }) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const history = useHistory();
  const query = useQuery();
  const { loading, list } = useAppSelector((state) => state.colors);
  const selectedColorsIds = selectedColors.map((color) => color.id);

  const stableDispatch = useCallback(dispatch, []);
  useEffect(() => {
    stableDispatch(loadColors());
  }, [stableDispatch]);

  const toggleColor = (item: Color) => {
    query.set("page", "1");
    query.set(
      "colors",
      selectedColors.length === 0
        ? JSON.stringify([item])
        : JSON.stringify(
            selectedColorsIds.includes(item.id)
              ? [...selectedColors.filter((color) => color.id !== item.id)]
              : [...selectedColors, item]
          )
    );
    history.push({
      pathname: location.pathname,
      search: query.toString(),
    });
  };

  return (
    <Fragment>
      <div className="filters-title">{I18n.general.chooseColor}</div>
      <List
        loading={loading !== "succeeded"}
        dataSource={list}
        grid={{ gutter: 4 }}
        renderItem={(item) => (
          <List.Item className="filters-size-section-list-item">
            <Button
              shape="circle"
              size="small"
              className="colors-list-item"
              style={{ backgroundColor: item.color }}
              onClick={() => toggleColor(item)}
            >
              {selectedColorsIds.includes(item.id) ? <CheckOutlined /> : " "}
            </Button>
          </List.Item>
        )}
      />
    </Fragment>
  );
};

export default Colors;
